import HCLDX from "@system/config/hcldx";
import Constants from "src/helper/Constants";
import System from "src/helper/system";

class CheckOut {
    static GET_PAYMENT_METHOD = System.getCartUrl() + '/api/paymentmethod/list';
    static ORDER_VALIDATE = System.getCartUrl() + '/api/order/validate';
    static TAX_EXEMPT_FILE_UPLOAD = System.getUserUrl() + '/api/user/amer/upload/taxExempt';

    static getCheckOutRouteURL() {
        return HCLDX.baseURL() + '/shop/check-out';
    }

    static getCheckOutStatusRouteURL() {
       return HCLDX.baseURL() + '/shop/order-confirmation';

    }
}

export default CheckOut;